var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-text","size":"sm","hide-header":"","hide-footer":"","centered":""}},[_c('p',{staticClass:"header py-2"},[_vm._v("กรุณารอรับอีเมล")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }